export const scheduledCallPreview = (commType: unknown, schedTime: unknown): string => {
  const seconds = Number(schedTime || 0);
  const start = seconds ? new Date(seconds * 1000) : null;
  const when = start
    ? start.toLocaleDateString() + " " + start.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    : "Soon";
  return `📅 ${commType || "audio"} scheduled • ${when}`;
};
